import { useEffect as r } from "react";
import { isBrowser as e } from "./env.js";
const i = () => {
  r(() => {
    if (e() && "scrollRestoration" in window.history)
      return window.history.scrollRestoration = "manual", () => {
        window.history.scrollRestoration = "auto";
      };
  }, []);
}, l = (t) => {
  const o = document.getElementById(t);
  o && o.scrollIntoView({ behavior: "smooth" });
};
export {
  l as smoothScrollToElementId,
  i as useManualScrollRestoration
};
